"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GroupPaperclip_1 = require("../../../../gen-src/icons/GroupPaperclip");
var Localize_1 = require("../../../../gen-src/Localize");
function tableDatabaseName(table) {
    if (table.__typename === 'DatabaseTable' && table.database) {
        return table.database.name;
    }
    return null;
}
function tableDatabaseHostName(table) {
    if (table.__typename === 'DatabaseTable' && table.database && table.database.__typename === 'DatabaseServer') {
        return table.database.hostName;
    }
    return null;
}
function tableFilePath(table) {
    if (table.__typename === 'DatabaseTable' && table.database && table.database.__typename === 'File') {
        return table.database.filePath;
    }
    return null;
}
function tableDatabaseGroupIcon(table) {
    if (table.__typename === 'DatabaseTable' && table.database && table.database.isGrouped) {
        // If the feature flag is disabled, isGrouped will still be falsy, so display no icon.
        return React.createElement(GroupPaperclip_1.SvgGroupPaperclip, null);
    }
    return null;
}
exports.tableDatabaseGroupIcon = tableDatabaseGroupIcon;
function tableDatabaseCellTitle(table) {
    var _a;
    if (table.__typename === 'DatabaseTable' && table.database && table.database.isGrouped) {
        return Localize_1.Messages.GroupedDatabaseTitle({ name: (_a = tableDatabaseName(table), (_a !== null && _a !== void 0 ? _a : '')) });
    }
    return null;
}
exports.tableDatabaseCellTitle = tableDatabaseCellTitle;
function getDatabaseDisplayString(table) {
    var databaseName = tableDatabaseName(table);
    var databaseHostName = tableDatabaseHostName(table);
    var filePath = tableFilePath(table);
    if (filePath) {
        return filePath;
    }
    else if (databaseName) {
        return databaseHostName
            ? Localize_1.Messages.DatabaseWithHostname({ databaseName: databaseName, databaseHostName: databaseHostName })
            : databaseName;
    }
    else {
        return '';
    }
}
exports.getDatabaseDisplayString = getDatabaseDisplayString;
//# sourceMappingURL=DatabaseNameCell.js.map